import React from 'react'
import injectStyles from 'react-jss'
import moment from 'moment'

import { styles } from './styles'
import { Card } from '@material-ui/core'
import cn from 'classnames'
import { SectionTitle } from '../../../Components/Section'
import { Row } from 'react-bootstrap'
import Switch from '../../../Components/Form/Switch'
import SimpleTableTable from '../../../Components/SimpleTableTable'
import { ButtonDeleteInline } from '../../../Components/Buttons/ButtonDeleteInline'

const header = [
  'State Name',
  'State Code',
  'URL',
  'Uploaded By',
  'Uploaded At',
  'Actions',
]

const trimURL = url => url.slice(0, url.indexOf('?'))

const TaxExemptionSection = ({
  classes,
  isTaxExemptionEnabled,
  setIsTaxExemptionEnabled = () => {},
  handleOpenModal = () => {},
  uploadedDocumentsForUnitedStatesStates,
  handleDeleteTaxExemptionByState = () => {},
  disableAction = false,
}) => {
  const postRowRender = row => {
    return {
      'State Name': row.name,
      'State Code': row.stateCode,
      'URL': (
        <a
          className={classes.link}
          target="_blank"
          href={row.url}
          rel="noreferrer"
        >
          {trimURL(row.url)}
        </a>
      ),
      'Uploaded By': row.uploadedBy,
      'Uploaded At': moment(Number(row.createdAt)).format('YYYY-MM-DD'),
      'Actions': (
        <div className={classes.actionButtons}>
          <ButtonDeleteInline
            onClickHandler={async () => {
              await handleDeleteTaxExemptionByState(row)
            }}
          />
        </div>
      ),
    }
  }

  return (
    <Card className={classes.wrapper}>
      <Row xs={12}>
        <SectionTitle className={cn('section-title-inline', classes.title)}>
          <div>Tax Exemption</div>
          <div>
            <Switch
              value={isTaxExemptionEnabled}
              disabled={disableAction}
              input={{
                onChange: e => setIsTaxExemptionEnabled(e.target.checked),
              }}
            />
          </div>
        </SectionTitle>
      </Row>
      <div className={classes.contentWrapper}>
        {uploadedDocumentsForUnitedStatesStates.length ? (
          <SimpleTableTable
            header={disableAction ? header.slice(0, -1) : header}
            data={uploadedDocumentsForUnitedStatesStates}
            postRowRender={postRowRender}
            showPages={false}
          />
        ) : null}

        {!disableAction ? (
          <div className={classes.buttonContainer}>
            <div onClick={handleOpenModal} className={classes.addButton}>
              <div>+</div>
            </div>
            <span className={classes.buttonLabel}>Add State</span>
          </div>
        ) : null}
      </div>
      <div />
    </Card>
  )
}

export default injectStyles(styles)(TaxExemptionSection)
